import axios from 'axios'
// 活动助手（收徒）
export function assistalive (params) {
  return axios.get('/s1/assist.alive', { params: params })
}
